























import { computed, defineComponent, ref } from "@vue/composition-api";
import { TagInfo, TagInfoType } from "@scrile/api-provider/dist/api/TagsProvider";
import { $t } from "@/lib/i18nHelpers";
import BaseButton from "@/components/BaseButton";
import TagsController from "@/components/TagsController";

export default defineComponent({
  name: "FilterTags",
  components: {
    BaseButton,
    TagsController,
  },
  props: {
    value: { type: Array as () => string[], required: true },
    tagsType: { type: String as () => TagInfoType, required: true },
  },
  setup(props, { emit }) {
    const clearCb = ref<() => void>(() => {});
    const isSelectedFilter = computed(() => !!props.value.length);
    const title = computed(() => (props.tagsType === TagInfoType.POSTS ? $t("HashTags") : $t("Categories")));

    const setClearCb = (cb: () => void) => {
      clearCb.value = cb;
    };

    const selectTags = (tags: TagInfo[]) => {
      emit(
        "input",
        tags.map(i => i.id)
      );
      emit("input:tags", tags);
    };

    const clear = () => {
      clearCb.value();
      selectTags([]);
    };

    return {
      isSelectedFilter,
      title,
      setClearCb,
      selectTags,
      clear,
    };
  },
});
